export const addQueryStringParameter = (str, key, value) => {
  const separator = str.indexOf('?') !== -1 ? '&' : '?'
  return str + separator + key + '=' + value
}
